// Physical LE store locations constants

export type Store = {
  name: string;
  displayName: string;
  utmMedium: string;
};

export type Stores = {
  [key: string]: Store;
};

const stores: Stores = {
  chadstone_store: {
    name: 'Chadstone',
    displayName: 'Chadstone Store',
    utmMedium: 'chadstone_store',
  },
  bondi_store: {
    name: 'Bondi',
    displayName: 'Bondi Store',
    utmMedium: 'bondi_store',
  },
  le_live: {
    name: 'LE LIVE',
    displayName: 'LE LIVE',
    utmMedium: 'lelive',
  },
};

export default stores;
